export const ERROR_MY_PROJECTS = 'innovatrix/ERROR_MY_PROJECTS';
export const FETCH_MY_PROJECTS = 'innovatrix/FETCH_MY_PROJECTS';
export const RECEIVE_MY_PROJECTS = 'innovatrix/RECEIVE_MY_PROJECTS';
export const ORDER_MY_CARDS = 'innovatrix/ORDER_MY_CARDS';
